
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared-property/[id]",
      function () {
        return require("private-next-pages/shared-property/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared-property/[id]"])
      });
    }
  